export const npsReviewsElementId = 'npsReviews';
